export const POPULATE_SUPPLIER = 'POPULATE_SUPPLIER';
export const CLEAN_SUPPLIER_MISSING = 'CLEAN_SUPPLIER_MISSING';
//-------- General Action ---------------------------
export const ERROR_API = 'ERROR_API';